<template>
  <div class="progress" @click.self="handleJump">
    <div class="progress__track" :style="{ width: value + '%' }"></div>
    <div
      ref="bar"
      @touchstart="onBegin"
      class="progress__bar"
      :style="{ left: value + '%' }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
  },
  mounted() {
    const handleMove = (evt) => {
      if (!this._isDown) {
        return;
      }
      const dis = evt.touches[0].pageX - this._dx;
      const t = Math.max(0, Math.min(this._left + dis, this._width));
      this.$refs.bar.style.left = t + "px";
      this.$emit("update:value", (t / this._width) * 100);
    };
    const handEnd = () => {
      if (!this._isDown) {
        return;
      }
      this.$emit("release");
      this._isDown = false;
      this.$nextTick(() => {
        this.$emit("change");
      });
    };
    document.addEventListener("touchmove", handleMove);
    document.addEventListener("touchend", handEnd);
    this.$once("hook:beforeDestroy", () => {
      document.removeEventListener("touchmove", handleMove);
      document.removeEventListener("touchend", handEnd);
    });
  },
  methods: {
    onBegin(evt) {
      this._dx = evt.touches[0].pageX;
      this._current = this.value;
      this._width = this.$el.clientWidth;
      this._left = evt.currentTarget.offsetLeft;
      this._isDown = true;
      this.$emit("handle");
    },
    handleJump(evt) {
      this._width = this.$el.clientWidth;
      const t = Math.max(0, Math.min(evt.offsetX, this._width));
      this.$emit("update:value", (t / this._width) * 100);
      this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.progress {
  height: 6px;
  background: #eeeeee;
  border-radius: 3px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    transform: scaleY(8);
  }

  @at-root &__track {
    background: $progress-track;//bb677a
    position: absolute;
    height: 6px;
    border-radius: 3px;
    pointer-events: none;
    z-index: 1;
    left: 0;
    top: 0; 
    right: 0;
  }
  @at-root &__bar {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 16px;
    position: absolute;
    right: 0;
    top: 3px;
    background: $progress-bar;//bb677a
    transform: translate(-50%, -50%);
    border: solid 1px #fff;
    box-sizing: content-box;
    z-index: 2;
    &::after {
      position: absolute;
      content: "";
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      transform: scale(4);
    }
  }
}
</style>
